import { Injectable } from '@angular/core';
import { BehaviorSubject, from, Observable, of, Subject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ConfigService } from '../config/config.service';
import { UserSessionService } from '../user-session/user-session.service';
import { WebservicesService } from '../webservices/webservices.service';

@Injectable({
  providedIn: 'root'
})
export class AvatarService {


  avatarList: any;

  public avatarListSubject = new BehaviorSubject<any>([]);

  constructor(
    private readonly config: ConfigService,
    private readonly userSession: UserSessionService,
    private readonly webservice: WebservicesService,
  ) { }

  private createAvatarList(response: any): void {
    if (response?.result === 1 && response?.payload) {
      this.avatarList = response.payload;
      this.avatarListSubject.next(this.avatarList);
    }
  }


  async getAvatarList() {
    try {
      const response = await this.getAvatars().toPromise();
      this.createAvatarList(response);
    } catch (error) {
      console.error('Get avatars error', error);
    }
  }


  getAvatars() {
    return this.webservice.get('configuration/get-avatars');
  }

  setAvatar(avatarId: number, customerId: number, nickname?: string): Observable<any> {
    const obj: any = {
      customer_id: customerId,
      session_token: this.userSession.getSessionToken(),
      avatar_id: avatarId,
    };

    if (nickname != null) {
      obj.nickname = nickname;
    }

    return this.webservice.post('customer/set-avatar', obj);
  }

  getAvatarImage(path: string): string {
    if (path !== undefined) {
      const cdnBaseUrl = this.config.getConfig().CDN_BASEURL;
      return cdnBaseUrl ? `${cdnBaseUrl}/assets/avatars/${path}` : '';
    }
    return '';
  }

  getAvatarById(id: number): Observable<any> {
    // Replace this with actual logic to fetch an avatar by its ID
    return this.webservice.get(`avatars/${id}`);
  }

  getCustomerAvatar(customerId){
    const obj: any = {
      customer_id: customerId,
      session_token: this.userSession.getSessionToken(),
    };
    return this.webservice.get('customer/get-avatar', obj);
  }
}
